//import axios from 'axios'
//import router from "@/router";

export default {
    state(){
        return {
            currentStep: null,
            userId: null,
            userDetails: null,
            userWorkstation: null
        }
    },

    getters: {

    },

    mutations: {

    },

    actions: {

    }
}